<template>
<div>
    <list v-if="men.list == true" v-on:item="menu" />
    <new-adviser v-if="men.new == true" v-on:item="menu" />
</div>
</template>

<script>
import list from "./list.vue";
import NewAdviser from "./new.vue";
export default {
    components: {
        list,
        NewAdviser
    },
    data() {
        return {
            men: {
                list: true,
                new: false,
            },
        }
    },
    mounted() {

    },
    methods: {
        menu(menu) {
            this.men = menu
        }
    },
}
</script>
